module.exports = __webpack_public_path__ + "skyblue-shape2.d5b0a40a80038d957518.png";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/skyblue-shape2.png
// module id = ../../../../../src/assets/img/skyblue-shape2.png
// module chunks = styles